import React from 'react';
import { MenuList, MenuOptionProps } from '../../menu-button/menu-list';

export type InvoiceActionMenuProps = {
  onEdit: (ev: React.MouseEvent) => void;
  onDelete: (ev: React.MouseEvent) => void;
};

export const InvoiceActionMenu: React.FC<InvoiceActionMenuProps> = ({
  onEdit,
  onDelete
}: InvoiceActionMenuProps) => {
  const menuOptions: MenuOptionProps[] = [
    {
      label: 'Edit',
      onClick: onEdit
    },
    {
      label: 'Delete',
      onClick: onDelete
    }
  ];
  return <MenuList options={menuOptions} />;
};
